import { iimReviewKeys } from '../../hooks/queryKeys';
import { withMockQueryClient } from '../../stories/mockQueryClient';
import AssessmentFeedback from './index';
const ASSESSMENT_ID = 42;
const meta = {
    title: 'Features/IIMReview/AssessmentFeedback',
    component: AssessmentFeedback,
    parameters: { layout: 'centered' },
    args: { assessmentId: ASSESSMENT_ID },
    decorators: [withMockQueryClient([])]
};
export default meta;
export const Default = {};
export const VotedUp = {
    decorators: [
        withMockQueryClient([
            { queryKey: iimReviewKeys.assessmentRating(ASSESSMENT_ID), scenario: { status: 'success', data: 'up' } }
        ])
    ]
};
export const VotedDown = {
    decorators: [
        withMockQueryClient([
            { queryKey: iimReviewKeys.assessmentRating(ASSESSMENT_ID), scenario: { status: 'success', data: 'down' } }
        ])
    ]
};
